import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { getDiscount } from '../../../../cartAndOrders/store/thunk'
import { SizeTracker } from '../../../../common/SizeTracker'
import useViewport from '../../../../common/hooks/useViewport'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import { Loading } from '../../../../common/loading'
import { Popup } from '../../../../common/popup'
import { ScrollComponent } from '../../../../common/scrollComponent'
import { selectUserType } from '../../../../layout/store/slice'
import { USER_TYPE } from '../../../../utils/authorization'
import classes from '../../../index.module.scss'
import { selectLoadingPlan, selectSubscriptionPlans } from '../../store/slice'
import { getSubscriptionPlans } from '../../store/thunk'
import { CUSTOM, CUSTOM_PLAN } from './constants'
import { PlanCard } from './planCard'

const POPUP = {
  MAX_WIDTH: 1400,
}

export const PopupUpgrade = ({ isShow, setIsShow }) => {
  const dispatch = useDispatch()

  const userType = useSelector(selectUserType)
  const data = useSelector(selectSubscriptionPlans)
  const locale = useSelector((state) => state.i18n.locale)
  const loading = useSelector(selectLoadingPlan)

  const { height, width } = useViewport()

  const handleClose = () => {
    setIsShow(false)
  }

  const getListPlan = [
    ...data?.filter((item) => item.id !== USER_TYPE.TRIAL),
    CUSTOM_PLAN,
  ]

  useEffect(() => {
    if (isShow) {
      dispatch(getSubscriptionPlans())
      dispatch(getDiscount())
    }
  }, [locale, isShow])

  return (
    <>
      {isShow && (
        <Popup
          zIndexPopup={99}
          appendStyleContent={{
            padding: 20,
            backgroundColor: '#F3F3F3',
            borderRadius: '4px',
            height: 0.95 * height,
            width: 0.85 * width,
            maxWidth: POPUP.MAX_WIDTH,
          }}
        >
          {loading ? (
            <div className="positionRelative h100">
              <Loading />
            </div>
          ) : (
            <SizeTracker
              renderTopComponent={() => (
                <TitlePopup handleClose={handleClose} />
              )}
            >
              {(size) => {
                return (
                  <div
                    className={[classes.popup].join(' ')}
                    style={{ height: `calc(100% - ${size.height}px)` }}
                  >
                    <div
                      className={['w100 flexRow h100', classes.content].join(
                        ' ',
                      )}
                      style={{
                        backgroundColor: '#FFFFFF',
                      }}
                    >
                      <ScrollComponent>
                        <div className={classes.cardContainer}>
                          {getListPlan?.map((item, index) => (
                            <PlanCard
                              key={item.id}
                              isActive={userType?.userTypeId === item.id}
                              isStandard={item.id === USER_TYPE.STANDARD}
                              isPremium={item.id === USER_TYPE.PREMIUM}
                              isCustom={item.code === CUSTOM}
                              isBasic={item.id === USER_TYPE.BASIC}
                              planData={getListPlan[index]}
                              itemKey={item.id}
                              setIsShow={setIsShow}
                            />
                          ))}
                        </div>
                      </ScrollComponent>
                    </div>
                  </div>
                )
              }}
            </SizeTracker>
          )}
        </Popup>
      )}
    </>
  )
}

const TitlePopup = ({ handleClose }) => {
  return (
    <Element
      className={[
        'dFlex justifyContentBetween alignItemsCenter',
        classes.header,
      ].join(' ')}
      style={{
        borderBottom: '1px solid #e5e5e8',
      }}
    >
      <Element
        elementName="span"
        className={classes.titleHeader}
        style={{
          fontSize: 20,
          fontWeight: 500,
          lineHeight: '24px',
          color: '#0553A5',
          width: `calc(100% - 30px)`,
        }}
      >
        <Translate value="userManagement.upgradeViewPlan.UPGRADE" />
      </Element>
      <Element onClick={handleClose}>
        <Icon
          className="icon-delete"
          style={{ fontSize: 12, color: '#9C9C9C' }}
        />
      </Element>
    </Element>
  )
}
